namespace $.$$ {

	export class $shm_ba_file_picker extends $.$shm_ba_file_picker {

		file_title() {
			const uri = this.file_uri()
			if( uri ) return this.remote_file_title_by_uri( uri ) ?? this.file_name()

			const key = this.local_file_key()
			if( key ) return this.local_file_title( key )

			return this.file_name()
		}

		file_name() {
			const file = this.file()
			const uri = this.file_uri()
			return file?.name || uri.split( '?' )[0].split( '/' ).pop() || 'Файл'
		}

		file( next?: File | null ) {
			if( next === undefined ) {
				const key = this.local_file_key()
				const file = this.files()[ 0 ] ?? null
				if( file && key && this.local_file_key_by_name( file.name ) === key ) return file
				if( file ) super.files( [] )
				return key ? this.local_file_read( key ) : null
			}
			this.files( next ? [ next ] : [] )
			return next
		}

		file_uri( next?: string ) {
			if( next === undefined ) return super.file_uri()
			super.files( [] )
			this.local_file_key( '' )
			return super.file_uri( next )
		}

		files( next?: readonly File[] ) {
			if( next === undefined ) return super.files()

			const files = super.files( next )
			if( next.length ) {
				const key = this.local_file_key_by_name( next[0].name )
				super.file_uri( '' )
				this.local_file_key( key )
				this.local_file_store( next[0] )
			}
			return files
		}

		rows() {
			return [
				this.Section( 'local' ),
				this.Section( 'remote' ),
			]
		}

		section_title( id: string ) {
			return id === 'local' ? 'Local' : 'Remote'
		}

		section_rows( id: string ) {
			return id === 'local'
				? [ this.Section_title( id ), this.File_open(), this.Local_files() ]
				: [ this.Section_title( id ), this.Remote_files(), this.File_uri() ]
		}

		local_file_prefix() {
			return this.$.$shm_ba_file_store.app_prefix( this.app_id() )
		}

		local_file_key_by_name( name: string ) {
			return `${ this.local_file_prefix() }${ name }`
		}

		local_file_name( key: string ) {
			return key.startsWith( this.local_file_prefix() )
				? key.slice( this.local_file_prefix().length )
				: key
		}

		@ $mol_action
		local_file_store( file: File ) {
			if( !file.size ) return
			$mol_wire_async( this ).local_file_store_async( file ).catch( error => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )
		}

		async local_file_store_async( file: File ) {
			const root = await navigator.storage.getDirectory()
			const key = this.local_file_key_by_name( file.name )
			const handle = await root.getFileHandle( key, { create: true } )
			const writable = await handle.createWritable()
			await writable.write( file )
			await writable.close()
			this.local_files_changed()
			return key
		}

		@ $mol_mem
		local_files_version( next?: number ) {
			return this.$.$shm_ba_file_store.version( this.local_file_prefix(), next )
		}

		local_files_changed() {
			return this.$.$shm_ba_file_store.changed( this.local_file_prefix() )
		}

		@ $mol_mem
		local_file_keys() {
			this.local_files_version()
			return $mol_wire_sync( this ).local_file_keys_async()
		}

		async local_file_keys_async() {
			const root = await navigator.storage.getDirectory()
			const prefix = this.local_file_prefix()
			const keys = [] as string[]
			for await( const [ name ] of ( root as any ).entries() ) {
				if( String( name ).startsWith( prefix ) ) keys.push( String( name ) )
			}
			return keys.sort()
		}

		local_file_rows() {
			return this.local_file_keys().map( key => this.Local_file( key ) )
		}

		local_file_title( key: string ) {
			return this.remote_file_title_by_name( this.local_file_name( key ) ) ?? this.local_file_name( key )
		}

		local_file_current( key: string ) {
			return this.local_file_key() === key
		}

		@ $mol_action
		local_file_select( file: File ) {
			const key = this.local_file_key_by_name( file.name )
			if( this.file_uri() ) this.file_uri( '' )
			this.local_file_key( key )
			super.files([ file ])
		}

		@ $mol_action
		local_file_pick( key: string, next?: Event ) {
			if( next === undefined ) return null
			this.local_file_select( this.local_file_read( key ) )
			this.showed( false )
			return next
		}

		@ $mol_mem_key
		local_file_read( key: string ) {
			return $mol_wire_sync( this ).local_file_read_async( key )
		}

		async local_file_read_async( key: string ) {
			const root = await navigator.storage.getDirectory()
			const handle = await root.getFileHandle( key )
			const file = await handle.getFile()
			const bytes = await file.arrayBuffer()
			return new File( [ bytes ], this.local_file_name( key ), { type: file.type || 'text/csv' } )
		}

		@ $mol_action
		local_file_delete( key: string, next?: Event ) {
			if( next === undefined ) return null
			$mol_wire_async( this ).local_file_delete_async( key ).catch( error => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )
			return next
		}

		async local_file_delete_async( key: string ) {
			const root = await navigator.storage.getDirectory()
			await root.removeEntry( key )
			if( this.local_file_key() === key ) {
				super.files( [] )
				super.file_uri( '' )
				this.local_file_key( '' )
			}
			this.local_files_changed()
		}

		remote_files() {
			const files = super.remote_files() as readonly $shm_ba_pb_file_item[]
			if( this.remote_files_forced() ) return files
			if( files.length ) return files

			return this.$.$shm_ba_pb.files( this.pb_files_collection(), this.pb_files_field() )
		}

		remote_file_rows() {
			return this.remote_files().map( file => this.Remote_file( file.id ) )
		}

		remote_file( id: string ) {
			return this.remote_files().find( file => file.id === id ) ?? null
		}

		remote_file_by_uri( uri: string ) {
			return this.remote_files().find( file => file.uri === uri ) ?? null
		}

		remote_file_name( file: $shm_ba_pb_file_item ) {
			return decodeURIComponent( file.uri.split( '?' )[0].split( '/' ).pop() || '' )
		}

		remote_file_title_by_uri( uri: string ) {
			return this.remote_file_by_uri( uri )?.title || null
		}

		remote_file_title_by_name( name: string ) {
			return this.remote_files().find( file => this.remote_file_name( file ) === name )?.title || null
		}

		remote_file_title( id: string ) {
			return this.remote_file( id )?.title ?? id
		}

		remote_file_current( id: string ) {
			return this.file_uri() === this.remote_file( id )?.uri
		}

		@ $mol_action
		remote_file_pick( id: string, next?: Event ) {
			if( next === undefined ) return null

			const file = this.remote_file( id )
			if( !file ) return next

			super.files( [] )
			this.file_uri( file.uri )
			this.local_file_key( '' )
			this.showed( false )
			return next
		}

	}

}
